// extracted by mini-css-extract-plugin
export default {"homePage":"home_homePage__Zkprp","container":"home_container__ZFw20","imgItem":"home_imgItem__IXfU5"};